import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzvwf3fa6z: FaireProductEntity = {
  token: "p_bzvwf3fa6z",
  type: "product",
  name: "Honey Bee Basil Seed Passion Fruit Flavor 290ml (Thailand)",
  brandToken: "b_s2gzfhxg44",
  brandName: "Global Bite Co",
  imageUrl:
    "https://cdn.faire.com/fastly/d3695c034bec568dccc2f456c8c0b7be3269aa226e37d8235e96d41095ad40ce.png",
  galleryImageUrls: [],
  priceDollars: 2.36,
  description:
    "Experience a refreshing twist with HB Basil Seed Passion Fruit Flavor. This 290ml beverage combines the sweet, exotic taste of passion fruit with the unique texture of basil seeds, offering a delightful and healthy drink option. Perfect for quenching your thirst and enjoying a burst of fruity flavor, HB Basil Seed Passion Fruit Flavor brings a touch of tropical refreshment to your day.\n",
  tags: [],
  msrpDollars: 4.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:26.489Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
